// useSoundInitializer.js
import { useEffect } from 'react';

const useSoundInitializer = () => {
  useEffect(() => {
    // Create a very short silent audio and play it on app start
    const silentAudio = new Audio();
    silentAudio.volume = 0;
    
    // Try to play silent audio to unlock audio context
    const unlockAudio = async () => {
      try {
        await silentAudio.play();
        silentAudio.pause();
      } catch (error) {
        console.log('Audio context needs user interaction');
      }
    };

    unlockAudio();
  }, []);
};

export default useSoundInitializer;